import { PublicClientApplication } from '@azure/msal-browser'
import config from './index'

const redirectUri = typeof window !== 'undefined' && window.location ? window.location.origin : ''

const msalConfig = {
  auth: {
    clientId: config.ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.ENTRA_TENANT_ID}`,
    redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

/** Scopes for the Glimpse API (must match backend ENTRA_AUDIENCE / app registration). */
export const loginRequest = {
  scopes: config.ENTRA_API_SCOPE ? [config.ENTRA_API_SCOPE] : [],
}

export const msalInstance = new PublicClientApplication(msalConfig)
